import { render, staticRenderFns } from "./DoctorPoster.vue?vue&type=template&id=abafbada&scoped=true&"
import script from "./DoctorPoster.vue?vue&type=script&lang=js&"
export * from "./DoctorPoster.vue?vue&type=script&lang=js&"
import style0 from "./DoctorPoster.vue?vue&type=style&index=0&id=abafbada&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abafbada",
  null
  
)

export default component.exports